/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { Fragment, useMemo } from 'react'
import Box from '@mui/material/Box'
import { useI18n } from '@popety_io/popety-io-lib'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import CancelIcon from '@mui/icons-material/Cancel'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

import GridHeader from '../Configuration/GridHeader'
import GridData from '../Configuration/GridData'
import CollapseList from './LandSummaryContent/CollapseList'

const Restrictions = ({ data }: { data: any }) => {
  const { t } = useI18n()

  const unaffectedRestrictions = useMemo(
    () =>
      data?.unAffectedRdppf?.map((rdppf: { name: string }) =>
        t(`land.restrictions.zone.${rdppf.name}`),
      ),
    [data],
  )

  const affectedRestrictions = useMemo(
    () =>
      data?.rdppfs
        ?.filter(
          (rdppf: { name: string }, index: number, self: any) =>
            self.findIndex((r: { name: string }) => r.name === rdppf.name) ===
            index,
        )
        ?.map((rdppf: { name: string }) =>
          t(`land.restrictions.zone.${rdppf.name}`),
        ),
    [data],
  )

  const data1 = [
    {
      label: '',
      value: affectedRestrictions?.length ? (
        <CollapseList
          sx={{ color: '#969696' }}
          items={affectedRestrictions}
          moreKey="common.seeMore"
        />
      ) : (
        <span style={{ color: '#969696' }}>
          {t('common.Pas de restrictions')}
        </span>
      ),
      name: '',
    },
  ]

  const data2 = [
    {
      label: '',
      value: (
        <CollapseList
          sx={{ color: '#969696' }}
          items={unaffectedRestrictions}
          moreKey="common.seeMore"
        />
      ),
      name: '',
    },
  ]

  return (
    <Box
      sx={{
        marginTop: '24px',
        marginBottom: '24px',
      }}
    >
      <Typography
        variant="h6"
        sx={{
          marginBottom: '4px',
          fontSize: '1.1rem',
          textTransform: 'uppercase',
          marginBlock: '10px',
        }}
      >
        {t('land.devScore.restrictions')}
      </Typography>{' '}
      <Box
        sx={{
          backgroundColor: '#F9F9F9',
          padding: '6px',
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={6} display="flex" flexDirection="column" gap={1.5}>
            <Box display="flex" gap={1}>
              <CancelIcon color="error" />

              <Typography fontSize="1.2rem" fontWeight="500">
                {t('common.Affectant la parcelle')}
              </Typography>
            </Box>
            {data1?.map((item: any) => (
              <Fragment key={item.label as string}>
                <Grid item xs={12} sm={8}>
                  {item.value}
                </Grid>
              </Fragment>
            ))}
          </Grid>
          <Grid item xs={6} display="flex" flexDirection="column" gap={1.5}>
            <Box display="flex" gap={1}>
              <CheckCircleIcon sx={{ color: '#8ed1a5' }} />
              <Typography fontSize="1.2rem" fontWeight="500">
                {t("common.N'affectant pas la parcelle")}
              </Typography>
            </Box>
            {data2?.map((item: any) => (
              <Fragment key={item.label as string}>
                <Grid item xs={12} sm={8}>
                  {item.value}
                </Grid>
              </Fragment>
            ))}
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export default Restrictions
